import React from 'react';
import { Trans } from 'react-i18next';

import { CardDescription, CardTitle } from 'shared/components/Card/Card.styles';
import {
  SupportCardBody,
  SupportCardContent,
  SupportCardIcon,
  SupportCardWrapper,
} from './SupportCard.styles';

type Props = {
  title: string;
  iconElement: JSX.Element;
  subHeader: string;
  onClick?: () => void;
  style?: any;
  width?: string;
  height?: string;
};

export function SupportCard({
  title,
  iconElement,
  subHeader,
  onClick,
  width,
  height,
  style,
}: Props) {
  return (
    <SupportCardWrapper onClick={onClick} $width={width} $height={height}>
      <SupportCardBody $cardHeight="100%" $cardWidth="100%" $enableInteractiveStyles style={style}>
        <SupportCardIcon>{iconElement}</SupportCardIcon>
        <SupportCardContent>
          <CardTitle as="h2">
            <Trans>{title}</Trans>
          </CardTitle>
          <CardDescription as="p">
            <Trans components={{ b: <b /> }}>{subHeader} </Trans>
          </CardDescription>
        </SupportCardContent>
      </SupportCardBody>
    </SupportCardWrapper>
  );
}

export default SupportCard;
